<template>
    <div>
        <DropDown>
            <template v-slot:dropdownLabel>

                {{ $t('modules.evaluations.index.bulkActions') }}
            </template>
            <template v-slot:dropdownItems>
                <a class="dropdown-item" @click="openAssignModal">{{ $t('modules.evaluations.index.bulkAssignPosition') }}</a>
            </template>
        </DropDown>

        <Modal @onConfirm="onConfirm" @onClose="onClose" :isOpen="AssignModalIsOpen" :modalTitle="$t('modules.evaluations.index.BulkAddEvalModalTitle')">
            <div class="select refs_select" v-if="positionsList.length > 0">
                <select v-model="selectedPosition">
                    <option v-for="position in positionsList" :index="position.id" :value="position" :key="position.id" >{{ position.name }}</option>
                </select>
            </div>
            <div class="refs_select_no_positions" v-else>
                <span>
                    {{ $t('modules.evaluations.index.evalsList.noPositionYet') }}
                </span>
            </div>
        </Modal>
    </div>
</template>

<script>
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'BulkActionsDropdown',
    props: ['positionsList'],
    components: {},
    data(){
        return {
            AssignModalIsOpen: false,
            selectedPosition: null
        }
    },
    computed: {
        selectedEvals(){
            return this.$store.state.EvalStore.selectedEvals
        }
    },
    methods: {
        openAssignModal(){
            if( userCanAccess('features', 'create_sight_group') &&  userCanAccess('features', 'create_evaluation')){
                this.AssignModalIsOpen = true
                this.$store.dispatch('PositionStore/indexPositions', {page: 'all'})
            }else{
                this.$router.push('/unautorized');
            }
        },
        onConfirm(){
            if(this.positionsList.length > 0){
                this.$store.dispatch('EvalStore/assignSelectedEvals', {sight_group_id: this.selectedPosition.id}).then(() => {
                    this.$store.dispatch('EvalStore/resetSelectedEvals')
                    setTimeout(() => { this.$store.dispatch('EvalStore/indexEvals', {}) }, 300)
                } )
                this.AssignModalIsOpen = false
            }else{
                this.AssignModalIsOpen = false
            }
            
        },
        onClose(){
            this.AssignModalIsOpen = false
        },
    }
}
</script>

<style lang="scss" scoped>
    .refs_select{
        width: 100%;
        select{
            width: 100%;
        }
    }

</style>